import React, { useState } from 'react';
import { MdOutlineArrowForwardIos } from 'react-icons/md';

export const FAQToggle = ({ question, answer }) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleOpen = () => {
		setIsOpen((prev) => !prev);
	};

	return (
		<div className="module-toggle">
			<div className={`toggle-item-wrapper ${isOpen ? 'active' : ''}`} onClick={toggleOpen}>
				<h3 className="toggle-item-heading h4">
					<span className="toggle-heading">{question}</span>
					<span className={`toggle-icon ${isOpen ? 'active' : ''}`}>
						<MdOutlineArrowForwardIos />
					</span>
				</h3>
				<div className="toggle-content">
					<div className="toggle-inner-content">
						<p className="toggle-item-description sm">{answer}</p>
					</div>
				</div>
			</div>
		</div>
	);
};
